import { FooterCopyright } from "./styles";

/**
 * フッターコピーライトコンポーネント
 *
 * @returns {JSX.Element} フッターコピーライトのコンポーネント
 */
export default function FooterCopyrightComponent() {
  return (
    <FooterCopyright>
      Copyright(C) <a href="https://www.direct-order.jp/">ダイレクトオーダー事務局</a> All Rights Reserved.
    </FooterCopyright>
  );
}
